import { baseApi } from "api/BaseApi";
import { PartialWith } from "api/common/utils/type.utils";

import { Maintenance } from "./maintenance.types";

const MAINTENANCE_BASE_QUERY = "/project/maintenance";

export const maintenanceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMaintenance: build.query<Maintenance, number>({
      query: (id) => `${MAINTENANCE_BASE_QUERY}/${id}/`,
      providesTags: (_result, _error, id) => [
        { type: "ASSURANCE_MAINTENANCE", id },
      ],
    }),
    maintenanceUpdate: build.mutation<
      Maintenance,
      PartialWith<Maintenance, "maintenance_id">
    >({
      query: (maintenance) => ({
        url: `${MAINTENANCE_BASE_QUERY}/${maintenance.maintenance_id}/`,
        method: "PUT",
        body: maintenance,
      }),
      invalidatesTags: (_result, _error, { maintenance_id }) => [
        { type: "ASSURANCE_MAINTENANCE", id: maintenance_id },
      ],
    }),
  }),
});

export const { useGetMaintenanceQuery, useMaintenanceUpdateMutation } =
  maintenanceApi;
